import { useTranslation } from 'next-i18next'

import { CategoryColorClasses } from '~/bootcamp/constants/bootcamp.const'
import { useAppSelector } from '~/redux/hooks'
import { selectVideoTopicColor } from '~/bootcamp/slices/vcc-data.slice'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import TimesBoldIcon from '~/components/Icons/svgs/TimesBoldIcon'

import UsefulWords from './UsefulWords'

import OtherResources from './OtherResources'

const BootcampPageHelp = ({
  className = '',
  onClose,
}: {
  className?: string
  onClose: () => void
}): React.ReactElement => {
  const { t } = useTranslation(['bootcamp', 'generics'])
  const colorInfo: CategoryColorClasses = useAppSelector(selectVideoTopicColor)

  return (
    <aside
      className={`border border-purple absolute w-75 bg-white px-5 py-4 rounded shadow-large space-y-2 ${className}`}
    >
      <div className="flex items-center justify-between">
        <h3 className={`${colorInfo.textClass} font-semibold text-md leading-6 mb-1`}>{t('usefulWords')}</h3>
        <button aria-label={t('generics:ariaLabelButtons.closeWindow')} onClick={onClose}>
          <SVGIcon icon={TimesBoldIcon} pathClassName="text-purple" size={20} />
        </button>
      </div>
      <div className="mb-4">
        <UsefulWords />
      </div>
      <h3 className={`${colorInfo.textClass} font-semibold text-md leading-6 mb-1`}>{t('bootcamp:otherResources')}</h3>
      <OtherResources />
    </aside>
  )
}

export default BootcampPageHelp
